export default {
  devClients: [
    'sphere-mail.spheremail.co',
    'spheremaillevel2.spheremail.co'
  ],
  urlExeptions: [
    '/phone_extensions', // 422 event on success, backend issue
    '/phone_numbers', // 422 event on success, backend issue, also post fails on staging
    '/validate_available', // returns 404 if user_name/email already taken
    '/validate_client', // returns 404 if subdomain already taken
    '/admin/accounts/find/', // returns 404 if only spaces
    '/shipping_rates',
    {
      url: '/admin/customers/', // 422 if customer not exists. in this case redirect to customers list anyway
      method: 'get'
    },
    '/mail_item', // 422 if no mail item does not exist, redirect to mail center
    '/account_transfers/clients', // 422 if no location, expected issue, have handling
    '/forward_addresses', // 422 on PUT and DELETE if has depending forward requests
    '/clients/', // 422 on PUT if company name is already taken, have backend error handling
    '/plans/', // 422 on DELETE if plan has subscribers, have handling
    '/admin/coupons', // 422 when creating dumplicate coupon code, have handling
    '/admin/accounts/import', // 422 if backend can't parse csv file, have handling
    'live_receptionist_service', // 422 if not allowed in plan, have handling
    '/port-number', // Have custom handling

    {
      url: '/account', // 422 if old password invalid or other form errors, have handling
      method: 'put'
    },
    {
      url: '/enable', // 422 activate custoemr, if invalid data was provided or missing data 
      method: 'post'
    },
    {
      url: '/credit_cards', // 422 if card expired (stripe only), have handling
      method: 'put'
    },
    {
      url: '/client/credit_card', // 422 if credit card is not valid, have handling
      method: 'post'
    },
    {
      url: '/charges', // common 422 on retry charge, have handling
      method: 'post'
    },
    {
      url: '/charges', // common 422 on retry charge, have handling
      method: 'put'
    },
    {
      url: '/coupon', // 404 if coupon is invalid, have handling
      method: 'post'
    },
    {
      url: '/admin/mail_items', // 422 for inactive customers on lvl3, however mail item updated even on error
      method: 'put'
    },
    {
      url: '/admin/client/access_api_docs', 
      method: 'put'
    },
    '/notarize_form1583',  // 422 if credit card is not valid, or has insufficient funds
    {
      url: '/client/officernd_configuration', 
      method: 'post'
    },
    {
      url: '/client/deskworks_configuration', 
      method: 'post'
    },
    {
      url: '/client/quickbooks_configuration', 
      method: 'post'
    },
    {
      url: '/client/nexudus_configuration', 
      method: 'post'
    }
  ],
  pathExeptions: [
    '/customers/admin/customer/', // windows file upload error (Network error)
    '/customers/customer/account', // windows file upload error (Network error)
  ]
}